<template>
  <Toast/>
  <div class="row">
    <div class="col">
      <h2 class="titre">Modification Sous Categorie</h2>
    </div>
  </div>
  <ModifierChamps v-if="showComponent" ref="modifierChamps" :isModifier="true"/>
  <ButtonBar @fermer="fermer" @sauvegarder="sauvegarder" :isSauvegardeEnCours="isSauvegardeEnCours"/>
  <DialogConfirmation ref="dialogConfirmation"/>
</template>

<script>
import axios from 'axios'
import {mapGetters} from 'vuex'
import ButtonBar from '../../../components/dossier/Modifier/ButtonBarSousCategorie.vue'
import ModifierChamps from '../../../components/dossier/Modifier/ModifierChampsSousCategorie.vue'
import DialogConfirmation from '../../../components/Commun/DialogConfirmation.vue'

export default {
  name: "ModifierSousCategorie",
  components: {
    ButtonBar,
    ModifierChamps,
    DialogConfirmation,
  },
  data() {
    return {
      isSauvegardeEnCours: false,
      showComponent: false,
      newSousCategorieLocal: [],
      sousCategorieASupprimer: [],
      listSousCategorieLocal: [],
    };
  },
  computed: {
    ...mapGetters({
      jeton: 'cardex/jeton',
      profil: 'cardex/profil',
    })
  },
  mounted() {

    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
    this.$root.$refs.breadcrumbComp.ajout("Modifier sousCategorie");
    this.getSousCategorieDossier();
  },
  methods: {
    async sauvegarder() {
      this.newSousCategorieLocal = this.$refs.modifierChamps.getNewSousCategorieLocal();
      this.sousCategorieASupprimer = this.$refs.modifierChamps.getSousCategorieASupprimer();
      if (this.sousCategorieASupprimer.length !== 0) {
          this.isSauvegardeEnCours = true;
          this.$store.commit('dossier/SUPPRIMER_LIEN_SOUS_CATEGORIE', this.sousCategorieASupprimer);
          let promise = await this.$store.dispatch('sousCategorie/supprimerSousCategorieAction', {sousCategorie: this.sousCategorieASupprimer,});
          if (promise.status == 200 || promise.status == 202 || promise.status == 201) {
              this.isSauvegardeEnCours = false;
              this.$toast.add({
                 severity: 'success',
                 summary: 'Modification',
                 detail: 'La liste de sous catégorie a été modifiée.',
                 life: 6000
              });
          }
        this.getSousCategorieDossier();
      }
      if (this.newSousCategorieLocal.length !== 0) {
        this.isSauvegardeEnCours = true;
        this.$store.dispatch('sousCategorie/ajouterSousCategorieAction', {
          sousCategorie: this.newSousCategorieLocal,
        }).then((res) => {
          this.$root.$refs.messagesComp.messagesList = res.data.messages;
          this.isSauvegardeEnCours = false;
          if (res?.data?.messages.length == 0) {
            this.$toast.add({
                severity: 'success',
                summary: 'Modification',
                detail: 'La liste de sous catégorie a été modifiée.',
                life: 6000
            });
            this.getSousCategorieDossier();
          }
        });
      }
    },
    fermer() {
      this.$root.$refs.breadcrumbComp.rediriger();
    },
    getSousCategorieDossier() {
      this.$store.dispatch("sousCategorie/recupererSousCategorieAction", {
        cle: this.$route.params.cleDossier,
        site: this.$route.params.siteDossier
      }).then((res) => {
        this.$store.commit('sousCategorie/LISTE_SOUS_CATEGORIE', res.data.entites);
        this.showComponent = true;
      });
    },
  },
  beforeRouteLeave(to, from, next) {
    return this.$refs.dialogConfirmation.confirmer(next, this.$refs.modifierChamps.getSousCategorieLocal(), this.$refs.modifierChamps.getAncienSousCategorie());
  },
}
</script>